import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, takeUntil, tap } from 'rxjs/operators';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import { EventTypes } from 'src/app/core/constants/event-types';
import {
  CustomResultOfPaginatedListOfSmartSmsClubsWithPaginationDto,
  GetEnumValuesDto,
  PaginatedListOfSmartSmsClubsWithPaginationDto,
  SmartSmsClubsWithPaginationDto,
} from '../../../../app/core/api/models';
import { SmartSmsClubsService } from '../../../core/api/services/smart-sms-clubs.service';
import { AppDomService } from '../../../core/services/dom.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { SmartSmsClubsFormComponent } from './smart-sms-clubs-form/smart-sms-clubs-form.component';

@Component({
  selector: 'app-smart-sms-clubs',
  templateUrl: './smart-sms-clubs.component.html',
  standalone: false,
})
export class SmartSmsClubsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = 'smartSmsClubs';
  modelWithPagination$: Observable<PaginatedListOfSmartSmsClubsWithPaginationDto>;
  items$: Observable<Array<SmartSmsClubsWithPaginationDto>>;
  formPageConfig: FormPageConfig<SmartSmsClubsWithPaginationDto> = {};
  isVisibleAddNumberForm: boolean = false;
  clubId: number;
  clubTitle: string;
  selectedClubId: any;
  isShowSmartSmsClubFileProgresses: boolean;
  isShowSmartSmsClubNumbers: boolean;
  isShowClubStatusInGateway: boolean = false;
  CreationLocationEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor(protected currentService: SmartSmsClubsService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.setPageService(this.currentService, 'smartSmsClubsCreateGet');
      this.pageConfig.showAuditBtn = false;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('EntityCreationLocation')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.CreationLocationEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: ``,
        name: '',
        hasSearch: false,
        noSorting: true,
        isCheckBox: true,
      },
      { title: this.localizer.id, name: 'id', hasSearch: true },
      { title: this.localizer.name, name: 'title', hasSearch: true },
      {
        title: 'common.creationLocation',
        name: 'creationLocation',
        hasSearch: true,
        type: 'enum',
        enumName: 'EntityCreationLocation',
        wrap: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfSmartSmsClubsWithPaginationDto> {
    return this.currentService.smartSmsClubsGetSmartSmsClubsWithPagination({
      body: this.getBaseModelWithPaginationParams(),
    });
  }

  // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      switch (key) {
        case QueryStringTypesEnum.Club_key:
          this.onShowChildPage({
            values: [...(value as string)?.split('_')],
            setUrl: false,
            queryStringKey: key,
            class: this,
            showPagePropKey: this.componentProperties.isVisibleAddNumberForm,
            selectedPropKey: [
              {
                keyName: this.componentProperties.clubId,
                keyType: typeof this.clubId,
              },
            ],
          });
          break;
      }
    }
  }

  //Delete
  // baseDeleteApi(id: number) {

  //   this.unSubs();

  //   this.pageConfig.loading = true;
  //   this.lastSelectedItemId = id;

  //   this.currentService.smartSmsClubsDelete({ body: { ids: id } })
  //     .pipe(this.basePipeOperators())
  //     .subscribe(this.baseDeleteObserver);

  // }

  deleteSmartSmsClubsApi(ids: number[]) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = ids;

    this.currentService
      .smartSmsClubsDelete({ body: { ids: ids } })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.selectedIds = []))
      )
      .subscribe(this.baseGroupDeleteObserver);
  }

  //#endregion

  //#region call Actions

  openCreateFormModal() {
    try {
      this.unSubs();

      let data = {
        title: `${this.formPageConfig?.vocabs}addTitle`,
        isEdit: false,
      };

      const modalResult = this.dialogService.openModal({
        component: SmartSmsClubsFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          finalize(() => (this.pageConfig.isVisibleForm = undefined)),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#endregion
  onAddNumbers(clubId, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Club_key +
          '=' +
          clubId
      );
    }
    this.clubId = clubId;
    this.isVisibleAddNumberForm = true;
  }

  onSmartSmsClubFileProgresses(clubId, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Club_key +
          '=' +
          clubId
      );
    }
    this.selectedClubId = clubId;
    this.isShowSmartSmsClubFileProgresses = true;
  }

  onSmartSmsClubNumbers(clubId, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    // if (setUrl) {
    //   this.location.go(
    //     window.location.pathname +
    //       '?' +
    //       QueryStringTypesEnum.Club_key +
    //       '=' +
    //       clubId
    //   );
    // }
    this.selectedClubId = clubId;
    this.isShowSmartSmsClubNumbers = true;
  }

  getFormResponse(isSuccess) {
    this.showParent = true;
    this.getParentQueryString();
    if (isSuccess) {
      this.getTableData();
      this.selectedIds = [];
    }
    this.isVisibleAddNumberForm = false;
    this.unSubs();
  }

  //#region group Deletion
  callGroupDeletion() {
    this.deleteSmartSmsClubsApi(this.selectedIds);
  }

  //#endregion

  onDelete(id: any, content: any, confirmByWritingText?: boolean) {
    const dialogResult = this.getConfirmDialog({
      content: content,
      isConfirmDelete: true,
      confirmByWritingText: confirmByWritingText,
    });

    dialogResult
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result) {
          this.pageConfig.loading = true;
          this.selectedIds = [];
          this.selectedIds.push(id);
          this.deleteSmartSmsClubsApi(this.selectedIds);
        }
      });
  }

  onClubStatusInGateway(id, title) {
    this.showParent = false;
    this.setParentQueryString();

    this.clubId = id;
    this.clubTitle = title;
    this.isShowClubStatusInGateway = true;
  }

  onHideClubStatusInGateway() {
    this.showParent = true;
    this.getParentQueryString();

    this.isShowClubStatusInGateway = false;
  }
}
